import { TFunction } from 'i18next'

import { TransactionsSalesTaxReturnsActionItem } from '../types/salesTaxReturnsActionItem'

export enum TransactionsSalesTaxReturnsActionType {
  VoidPayment = 'voidPayment',
  VoidSettlement = 'voidSettlement',
}

interface GetSalesTaxReturnsActionsProps {
  isVATPeriodSettled?: boolean
  isVATPeriodPaid?: boolean
  t: TFunction
}

export const getSalesTaxReturnsActions = ({
  isVATPeriodSettled,
  isVATPeriodPaid,
  t,
}: GetSalesTaxReturnsActionsProps): TransactionsSalesTaxReturnsActionItem[] => {
  if (isVATPeriodSettled && !isVATPeriodPaid) {
    return [
      {
        children: t('transactions.table.static_actions.sales_tax_returns.void_settlement'),
        id: TransactionsSalesTaxReturnsActionType.VoidSettlement,
        value: TransactionsSalesTaxReturnsActionType.VoidSettlement,
      },
    ]
  }

  if (isVATPeriodPaid) {
    return [
      {
        children: t('transactions.table.static_actions.sales_tax_returns.void_payment'),
        id: TransactionsSalesTaxReturnsActionType.VoidPayment,
        value: TransactionsSalesTaxReturnsActionType.VoidPayment,
      },
    ]
  }

  return []
}
